<router-outlet />
<app-toast/>
<app-spinner [isAdmin]="isAdmin"/>
